module.exports = __webpack_public_path__ + "img/manager.1f6c7463.jpeg";